import { handleActions } from 'redux-actions'
import {
  SHOW_SOURCE_SETUP,
  SET_SOURCE_SETUP_STEP,
  RECEIVED_TEST_SOURCE_SETTINGS,
  HIDE_SOURCE_SETUP,
  RESET_SOURCE_SETUP,
  UPDATE_SOURCE_SETUP_SOURCE
} from 'actions'

const initialState = {
  sourceSlug: null,
  step: 'hidden',
  isTestSuccessful: false,
  source: {}
}

export default handleActions({
  [RESET_SOURCE_SETUP] (state) {
    return {
      ...initialState,
      sourceSlug: state.sourceSlug,
      step: 'connect'
    }
  },
  [SHOW_SOURCE_SETUP] (state, { payload }) {
    return {
      ...initialState,
      sourceSlug: payload.slug,
      step: 'connect'
    }
  },
  [SET_SOURCE_SETUP_STEP] (state, { payload }) {
    return {
      ...state,
      step: payload
    }
  },
  [RECEIVED_TEST_SOURCE_SETTINGS] (state, { payload }) {
    const { response } = payload
    return {
      ...state,
      isTestSuccessful: response.errors.length === 0
    }
  },
  [HIDE_SOURCE_SETUP] (state) {
    return {
      ...state,
      step: 'hidden'
    }
  },
  [UPDATE_SOURCE_SETUP_SOURCE] (state, { payload }) {
    return {
      ...state,
      source: {
        ...state.source,
        ...payload,
        settings: {
          ...state.source.settings,
          ...payload.settings
        }
      }
    }
  }
}, initialState)



// WEBPACK FOOTER //
// ./reducers/application/source-setup.js